import React, { useState, useEffect, useCallback } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Swal from "sweetalert2";
import DataTable from "../component/DataTable";
import axiosInstance from "../axiosInterceptor";
import { toast } from "react-toastify";
import LightboxWrapper from "../component/LightboxWrapper";
import { GridActionsCellItem } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SweetAlert from "../component/SweetAlert";
import { Box, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NotificationHistory = () => {
  const navigate = useNavigate();

  const [rowsData, setRowsData] = useState([]);
  const [field, setField] = useState("");
  const [headerName, setHeaderName] = useState("");
  const [loading, setLoading] = useState(false);

  const baseColumns = [
    {
      field: "image_url",
      headerName: "Image",
      flex: 0.7,
      renderCell: (params) => {
        const thumbImage = params.value;
        if (!thumbImage) {
          return <span style={{ fontSize: "18px" }}>–</span>;
        }

        return (
          <LightboxWrapper>
            <img
              src={thumbImage}
              alt="Thumbnail"
              loading="lazy"
              style={{
                // width: 100,
                height: 100,
                objectFit: "cover",
                display: "block",
                backgroundColor: "#000",
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.style.display = "none";
                e.target.parentNode.innerHTML =
                  "<span style='font-size:18px'>–</span>";
              }}
            />
          </LightboxWrapper>
        );
      },
    },
    {
      field: "title",
      headerName: "Title",
      flex: 1.3,
    },
    // {
    //   field: "body",
    //   headerName: "Description",
    //   flex: 1,
    // },
    {
      field: "customerIds",
      headerName: "Customers",
      flex: 0.5,
      renderCell: (params) => {
        const count = params.value?.length || 0;

        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Box
              sx={{
                width: 34,
                height: 34,
                borderRadius: "50%",
                backgroundColor: "#1976d2",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 600,
                fontSize: 14
              }}
            >
              {count}
            </Box>
          </Box>
        );
      }
    },
    // Grouped counts UI (click/unclick/send -> 1 column, block/deliveryCount -> 1 column)
    {
      field: "sendStats",
      headerName: "Send",
      flex: 0.7,
      sortable: false,
      renderCell: (params) => {
        const row = params.row || {};
        const clickCount = row.clickCount ?? 0;
        const unclickCount = row.unclickCount ?? 0;
        const sendCount = row.sendCount ?? 0;

        const Line = ({ label, value, labelColor }) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              gap: 1.5,
            }}
          >
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 700,
                color: labelColor,
                whiteSpace: "nowrap",
                textAlign: "left",
                flex: "1 1 auto",
                letterSpacing: "0.2px",
              }}
            >
              {label}
            </Typography>
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 600,
                whiteSpace: "nowrap",
                textAlign: "right",
              }}
            >
              {value}
            </Typography>
          </Box>
        );

        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "stretch",
              gap: 0.35,
              px: 1,
            }}
          >
            <Line
              label="Click"
              value={clickCount}
              labelColor="#16a34a"
            />
            <Line
              label="Unclick"
              value={unclickCount}
              labelColor="#f97316"
            />
            <Line
              label="Send"
              value={sendCount}
              labelColor="#2563eb"
            />
          </Box>
        );
      },
    },
    {
      field: "blockDeliveryStats",
      headerName: "Block / Delivery",
      flex: 0.7,
      sortable: false,
      renderCell: (params) => {
        const row = params.row || {};
        const blockCount = row.blockCount ?? 0;
        const deliveryCount = row.deliveryCount ?? 0;

        const Line = ({ label, value, labelColor }) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              gap: 1.5,
            }}
          >
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 700,
                color: labelColor,
                whiteSpace: "nowrap",
                textAlign: "left",
                flex: "1 1 auto",
                letterSpacing: "0.2px",
              }}
            >
              {label}
            </Typography>
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 600,
                whiteSpace: "nowrap",
                textAlign: "right",
              }}
            >
              {value}
            </Typography>
          </Box>
        );

        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "stretch",
              gap: 0.35,
              px: 1,
            }}
          >
            <Line
              label="Block"
              value={blockCount}
              labelColor="#dc2626"
            />
            <Line
              label="Deliver"
              value={deliveryCount}
              labelColor="#10b981"
            />
          </Box>
        );
      },
    },
    {
      field: "notificatioType",
      headerName: "Notificatio Type",
      flex: 1,
    },
    {
      field: "createdAt",
      headerName: "Created Date",
      flex: 1,
      renderCell: (params) => {
        const date = new Date(params.value);
        return new Intl.DateTimeFormat("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }).format(date)
          .replace(/am|pm/i, (m) => m.toUpperCase());
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.6,
      sortable: false,
      renderCell: (params) => (
        <>
          <GridActionsCellItem
            icon={
              <Tooltip title="View">
                <VisibilityIcon color="primary" />
              </Tooltip>
            }
            label="View"
            showInMenu={false}
            onClick={() => handleView(params.id)}
          />
          <GridActionsCellItem
            icon={
              <Tooltip title="Delete">
                <DeleteIcon color="error" />
              </Tooltip>
            }
            label="Delete"
            showInMenu={false}
            onClick={() => handleDelete(params.id)}
          />
        </>
      ),
    },
  ];

  const [columns, setColumns] = useState(baseColumns);
  const [totalRecords, setTotalRecords] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const groupedCountFields = [
    "unclickCount",
    "clickCount",
    "sendCount",
    "deliveryCount",
    "blockCount",
  ];

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axiosInstance.get(`notificationHistory/pagination?page=${paginationModel.page + 1}&limit=${paginationModel.pageSize}`);

      if (data?.data) {
        setRowsData(data.data);
        setTotalRecords(data.totalRecords);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong!";
      toast.error(errMsg);
    } finally {
      setLoading(false);
    }
  }, [paginationModel.page, paginationModel.pageSize]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);


  const keys = rowsData.length > 0 ? Object.keys(rowsData[0]) : [];

  const handleAddColumn = (e) => {
    e.preventDefault();

    if (!field || !headerName) return;

    const normalizedField = field.trim();
    if (groupedCountFields.includes(normalizedField)) {
      Swal.fire(
        "Already grouped",
        "These fields are displayed inside the grouped Send / Block / Delivery columns.",
        "info"
      );
      return;
    }

    const isDuplicate = columns.some((col) => col.field === normalizedField);
    if (isDuplicate) {
      Swal.fire("Field already exists!", "", "warning");
      return;
    }

    const newColumn = {
      field: normalizedField,
      headerName: headerName.trim(),
      flex: 1,
    };

    const actionCol = columns.find((col) => col.field === "actions");
    const otherCols = columns.filter((col) => col.field !== "actions");

    setColumns([...otherCols, newColumn, actionCol]);
    setField("");
    setHeaderName("");
  };

  const handleDelete = async (notification_id) => {
    try {
      const confirmed = await SweetAlert.confirmDelete();
      if (!confirmed) return;

      const response = await axiosInstance.delete(`notificationHistory/delete/${notification_id}`);
      setRowsData((prev) => prev.filter((row) => row.id !== notification_id));
      SweetAlert.deleteSuccess();
      if (response?.data?.isSuccess) {
        fetchData();
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong!";
      toast.error(errMsg);
    }
  };

  const handleView = (notification_id) => {
    if (!notification_id) return;
    navigate(`/notification-history/${notification_id}`);
  };

  return (
    <div className="content-wrapper pd-top">
      <div className="page-header mt-5">
        <h3 className="page-title">Notifications History</h3>
      </div>

      {/* Column Add Form */}
      <div className="mb-4 d-flex justify-content-between align-items-center">
        <div style={{ width: "100%" }}>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography component="span">
                <h5 className="m-0">Add Dynamic Column</h5>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <form
                onSubmit={handleAddColumn}
                className="p-3 border rounded bg-white"
              >
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group mb-3">
                      <label>Field</label>
                      <select
                        className="form-control"
                        value={field}
                        onChange={(e) => setField(e.target.value)}
                      >
                        <option value="" disabled>
                          Select a field
                        </option>
                        {keys
                          .filter((key) => !groupedCountFields.includes(key))
                          .map((key, idx) => (
                            <option key={idx} value={key}>
                              {key}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-3">
                      <label>Header Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={headerName}
                        onChange={(e) => setHeaderName(e.target.value)}
                        placeholder="e.g. Email"
                      />
                    </div>
                  </div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <button type="submit" className="btn btn-primary">
                    Add Column
                  </button>
                </div>
              </form>
            </AccordionDetails>
          </Accordion>
        </div>
      </div>

      {/* Data Table */}
      <div className="row">
        <div className="col-lg-12">
          <DataTable
            key={paginationModel.page}
            rows={rowsData}
            columns={columns}
            getRowId={(row) => row._id}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            rowCount={totalRecords}
            paginationMode="server"
            loading={loading}
            disableVirtualization
            getRowHeight={() => 100}
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationHistory;
